<template>
  <base-code-message
      :message="message"
      :run="runOrStop"
      :can-stop="true">
  </base-code-message>
</template>

<script>
import WebPythonWorker from '@/plugin/web_ide/WebPythonWorker'
import BaseCodeMessage from '@/components/classroom/messages/partials/BaseCodeMessage'

const IDE = window['IDE']

export default {
  components: { BaseCodeMessage },
  props: ['message'],
  data () {
    return {
      python: new WebPythonWorker()
    }
  },
  beforeDestroy () {
    // this.stopCodeRunning()
  },
  methods: {
    runOrStop (code, shell) {
      if (shell.status === 'running') {
        this.stopCodeRunning(shell)
      } else {
        this.runCode(code, shell)
      }
    },
    async runCode (code, shell) {
      if (!code) return
      try {
        this.python.inputfun = async (dialogConfig) => {
          const ret = await IDE.getInput(dialogConfig, 300, () => {
            this.stopCodeRunning(shell)
          })
          shell.input = ret.prompt + ret.value + '\n'
          return ret
        }

        shell.output = '代码运行中...'
        shell.error = ''
        shell.status = 'running'
        shell.startAt = Date.now()
        shell.endAt = 0

        await this.python.run(code, shell, shell)
        if (!shell.output) shell.output = '运行结束'
      } catch (success) {
        shell.status = 'error'
        if (!shell.error) shell.error = '运行结束'
      } finally {
        shell.status = 'stop'
        shell.endAt = Date.now()
      }
    },
    async stopCodeRunning (shell) {
      this.python.terminate()
      shell.status = 'terminate'
    }
  }
}
</script>
